import React, { useCallback, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { StyleSheet, Image, View, Text, TouchableWithoutFeedback } from 'react-native';
import { langMap } from "./lang";
import { lrpx } from "./common/utils";
import { getLanguage } from "./common/i18n";
import ProviderItem from "./ProviderItem";
import showMoreImg from "./assets/images/show-more.png";
const Styles = StyleSheet.create({
  cashierProvider: {
    paddingLeft: lrpx(19),
    paddingRight: lrpx(19),
    paddingTop: lrpx(16)
  },
  showMoreBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: lrpx(25)
  },
  showMoreText: {
    fontSize: lrpx(14),
    color: '#000000e0'
  },
  payMethodIcon: {
    width: lrpx(28),
    height: lrpx(28),
    marginRight: lrpx(9)
  },
  showMoreIcon: {
    marginLeft: lrpx(6),
    height: lrpx(8),
    width: lrpx(12)
  },
  mainTitle: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: lrpx(5)
  },
  textNode: {
    display: 'flex',
    flexDirection: 'row',
    lineHeight: lrpx(22),
    fontSize: lrpx(16),
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#000000'
  }
});
const DEFAULT_SHOW_ITEM_NUM = 3;
const CashierProvider = (props, ref) => {
  var _langMap$loadLanguage, _langMap$loadLanguage2;
  const {
    cashierConfigs,
    selectedPayMethod,
    showItemNum = DEFAULT_SHOW_ITEM_NUM,
    language,
    isShowTitle = true,
    onCashierConfigSelected,
    onExpand,
    callback
  } = props;
  // 面板折叠状态，默认为true，后续根据formatConfig与showItemNum计算
  const [foldState, setFoldState] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [providerConfig, setProviderConfig] = useState([]);
  const [showProviders, setShowProviders] = useState([]);
  const [foldProviders, setFoldProviders] = useState([]);
  const loadLanguage = getLanguage(language);
  useImperativeHandle(ref, () => ({
    getCashierParams: () => {
      const selected = providerConfig[selectedIndex];
      return {
        paymentMethod: selected === null || selected === void 0 ? void 0 : selected.payment_method,
        paymentType: selected === null || selected === void 0 ? void 0 : selected.payment_type,
        requestField: selected === null || selected === void 0 ? void 0 : selected.request_field
      };
    }
  }));
  useEffect(() => {
    try {
      // eslint-disable-next-line @es/code-spec-unid/no-json-parse-or-json-stringify
      const pConfig = JSON.parse(cashierConfigs);
      setProviderConfig(pConfig);
      if (selectedPayMethod === 'NULL_PAYMENT_METHOD') {
        // 若传入默认选择渠道值为NULL_PAYMENT_METHOD，则不选择支付方式
        setSelectedIndex(-1);
      } else {
        const sIndex = pConfig.findIndex(item => {
          return item.payment_method === selectedPayMethod;
        });
        // 返选默认选择的渠道，若无默认选择渠道则选中第一项
        setSelectedIndex(sIndex === -1 ? 0 : sIndex);
      }
    } catch (error) {
      throw 'CONFIG_ERROR';
    }
  }, [cashierConfigs, selectedPayMethod]);
  useEffect(() => {
    const showItems = [];
    const expandItems = [];
    // 初始化数据对应的折叠状态
    const initFoldState = providerConfig.length > showItemNum;

    // providerConfig不存在时，不计算列表展示数组
    if (providerConfig.length === 0) return;
    if (foldState && initFoldState) {
      providerConfig.map(item => {
        if (providerConfig.indexOf(item) > showItemNum - 1) {
          expandItems.push(item);
        } else {
          showItems.push(item);
        }
      });
    } else {
      setFoldState(false);
      providerConfig.map(item => {
        showItems.push(item);
      });
    }
    setShowProviders(showItems);
    setFoldProviders(expandItems);
  }, [providerConfig, showItemNum, foldState]);
  const togglePress = useCallback(() => {
    setFoldState(false);
    onExpand && onExpand();
  }, [onExpand]);
  return /*#__PURE__*/React.createElement(View, {
    style: Styles.cashierProvider
  }, isShowTitle && /*#__PURE__*/React.createElement(View, {
    style: Styles.mainTitle
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles.textNode
  }, (_langMap$loadLanguage = langMap[loadLanguage]) === null || _langMap$loadLanguage === void 0 ? void 0 : _langMap$loadLanguage.PayMethod)), showProviders.map((item, renderIndex) => {
    return /*#__PURE__*/React.createElement(ProviderItem, {
      key: item.payment_method,
      itemData: item,
      renderIndex: renderIndex,
      isSelected: renderIndex === selectedIndex,
      onSelected: (currentSelectedItem, currentSelectedIndex) => {
        setSelectedIndex(currentSelectedIndex);
        onCashierConfigSelected && onCashierConfigSelected(currentSelectedItem);
      },
      callback: callback
    });
  }), foldProviders.length > 0 && /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: togglePress
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles.showMoreBlock
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles.showMoreText
  }, (_langMap$loadLanguage2 = langMap[loadLanguage]) === null || _langMap$loadLanguage2 === void 0 ? void 0 : _langMap$loadLanguage2.ViewMore), /*#__PURE__*/React.createElement(Image, {
    resizeMode: "contain",
    style: Styles.showMoreIcon,
    source: showMoreImg
  }))));
};
export default /*#__PURE__*/forwardRef(CashierProvider);